import { render, staticRenderFns } from "./UserClientList.vue?vue&type=template&id=190437f4"
import script from "./UserClientList.vue?vue&type=script&lang=js"
export * from "./UserClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports